import { ArrayElement, ImgAssetUrl, Ingredients } from '../types';
import { validKeyboardKey } from './general';

export const ingredientPrices: Record<Ingredients, number> = {
  [Ingredients.DOUGH]: 1,
  [Ingredients.TOMATO_SAUCE]: 2,
  [Ingredients.CREAM_SAUCE]: 2,
  [Ingredients.HAM]: 3,
  [Ingredients.PEPPERONI]: 3,
  [Ingredients.CHICKEN]: 4,
  [Ingredients.BEEF]: 4,
  [Ingredients.SALMON]: 5,
  [Ingredients.TUNA]: 5,
  [Ingredients.CHEESE]: 1,
  [Ingredients.GOAT_CHEESE]: 2,
  [Ingredients.BLUE_CHEESE]: 3,
  [Ingredients.MUSHROOMS]: 2,
  [Ingredients.PEPPERS]: 2,
  [Ingredients.POTATOS]: 1,
  [Ingredients.OLIVES]: 3,
  [Ingredients.HERBS]: 1,
  [Ingredients.ONIONS]: 3,
  [Ingredients.HONEY]: 4,
  [Ingredients.PINEAPPLE]: 4,
};

export const ingredientsKeyboardDefaultMapping: Record<
  Ingredients,
  ArrayElement<typeof validKeyboardKey>
> = {
  [Ingredients.DOUGH]: 'D',
  [Ingredients.TOMATO_SAUCE]: 'T',
  [Ingredients.CREAM_SAUCE]: 'C',
  [Ingredients.HAM]: 'H',
  [Ingredients.PEPPERONI]: 'P',
  [Ingredients.CHICKEN]: 'V',
  [Ingredients.BEEF]: 'F',
  [Ingredients.SALMON]: 'S',
  [Ingredients.TUNA]: 'U',
  [Ingredients.CHEESE]: 'M',
  [Ingredients.GOAT_CHEESE]: 'G',
  [Ingredients.BLUE_CHEESE]: 'B',
  [Ingredients.MUSHROOMS]: 'R',
  [Ingredients.PEPPERS]: 'E',
  [Ingredients.POTATOS]: 'Q',
  [Ingredients.OLIVES]: 'O',
  [Ingredients.HERBS]: 'I',
  [Ingredients.ONIONS]: 'N',
  [Ingredients.HONEY]: 'Y',
  [Ingredients.PINEAPPLE]: 'A',
};

export const IngredientsImageMap: Record<Ingredients, ImgAssetUrl> = {
  [Ingredients.DOUGH]: 'dough.png',
  [Ingredients.TOMATO_SAUCE]: 'tomato-sauce.png',
  [Ingredients.CREAM_SAUCE]: 'cream.png',
  [Ingredients.HAM]: 'ham.png',
  [Ingredients.PEPPERONI]: 'pepperoni.png',
  [Ingredients.CHICKEN]: 'chicken.png',
  [Ingredients.BEEF]: 'beef.png',
  [Ingredients.SALMON]: 'salmon.png',
  [Ingredients.TUNA]: 'tuna.png',
  [Ingredients.CHEESE]: 'mozzarella.png',
  [Ingredients.GOAT_CHEESE]: 'goat-cheese.png',
  [Ingredients.BLUE_CHEESE]: 'blue-cheese.png',
  [Ingredients.MUSHROOMS]: 'mushroom.png',
  [Ingredients.PEPPERS]: 'peppers.png',
  [Ingredients.POTATOS]: 'potato.png',
  [Ingredients.OLIVES]: 'olives.png',
  [Ingredients.HERBS]: 'origan.png',
  [Ingredients.ONIONS]: 'onions.png',
  [Ingredients.HONEY]: 'honey.png',
  [Ingredients.PINEAPPLE]: 'pineapple.png',
};
